import { ContactType, FindAllContactsFilters, FindContactsDatabaseResponse } from "../../../../lib/filters/dto";
import { DatabaseSection, TargetSection } from "../../../../lib/utils";
import { NotFound } from "../../../../ui/organisms/notFound";
import { ItemsPerPageValues } from "../../../../ui/organisms/pagination/dto";
import { Pagination } from "../../../../ui/organisms/pagination/index";
import { CompaniesTable } from "./table";

interface Props {
  filters: FindAllContactsFilters
  section: DatabaseSection | TargetSection
  contacts: FindContactsDatabaseResponse<ContactType.COMPANY>
  selectedIds: string[]
  setSelectedIds: (ids: string[]) => void
  onPageChange: (page: number) => void
  onItemsPerPageChange: (itemsPerPage: ItemsPerPageValues) => void
  onChangeFilters: (filters: Partial<FindAllContactsFilters>) => void
}

export function CompaniesList(props: Props) {
  const { filters, section, contacts, selectedIds, setSelectedIds, onPageChange, onItemsPerPageChange, onChangeFilters } = props

  return (
    <div style={{ height: '100%' }}>
      {contacts?.data.length === 0 ||
        contacts?.data === null ? (
        <div style={{ height: 'calc(100% - 128px)' }}>
          <NotFound />
        </div>
      ) : (
        <CompaniesTable selectedIds={selectedIds} setSelectedIds={setSelectedIds} section={section} contacts={contacts!} filters={filters} updateFilters={onChangeFilters} />
      )}
      {
        !(contacts.data.length === 0 ||
          contacts.data === null) &&
        <Pagination
          itemsPerPage={filters.itemsPerPage}
          setItemsPerPage={onItemsPerPageChange}
          found={contacts.total || 0}
          key={"pagination-companies-bottom"}
          pages={contacts.totalPage || 0}
          currentPage={contacts.page || 0}
          setPage={onPageChange}
        />
      }
    </div>
  );
}
